import { Divider, Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const EmailTemplateDetailSkeleton = () => (
  <Styles.Container>
    <Styles.TitleAndDescriptionContainer>
      <Skeleton variant="text" width="15%" height={12} />
      <Skeleton variant="rounded" width="100%" height={32} />
      <Skeleton variant="rounded" width="100%" height={64} />
    </Styles.TitleAndDescriptionContainer>
    <Divider />
    <Styles.EmailContentContainer>
      <Styles.HeaderRow>
        <Styles.HeaderTitleContainer>
          <Skeleton variant="text" width={120} height={24} />
          <Skeleton variant="text" width="50%" height={16} />
        </Styles.HeaderTitleContainer>
        <Skeleton variant="rounded" width={210} height={40} />
      </Styles.HeaderRow>
      <Styles.TabsRow>
        <Skeleton variant="text" width={80} height={20} />
        <Skeleton variant="text" width={80} height={20} />
      </Styles.TabsRow>
      <Skeleton variant="text" width={60} height={20} />
      <Styles.SubjectRow>
        <Styles.SubjectInputContainer>
          <Skeleton variant="text" width="12%" height={12} />
          <Skeleton variant="rounded" width="100%" height={32} />
        </Styles.SubjectInputContainer>
        <Skeleton variant="rounded" width={120} height={32} />
        <Skeleton variant="circular" width={24} height={24} />
      </Styles.SubjectRow>
      <Styles.BodyContainer>
        <Skeleton variant="text" width={50} height={20} />
        <Styles.TabsRow>
          <Skeleton variant="text" width={60} height={20} />
          <Skeleton variant="text" width={120} height={20} />
          <Skeleton variant="text" width={80} height={20} />
        </Styles.TabsRow>
        <Styles.EditorToolbar>
          {Array.from({ length: 3 }).map((_, index) => (
            <Skeleton key={index} variant="rounded" width={100} height={28} />
          ))}
          {Array.from({ length: 8 }).map((_, index) => (
            <Skeleton key={`icon-${index}`} variant="circular" width={28} height={28} />
          ))}
        </Styles.EditorToolbar>
        <Styles.EditorBody>
          <Skeleton variant="text" width="60%" height={16} />
        </Styles.EditorBody>
      </Styles.BodyContainer>
    </Styles.EmailContentContainer>
  </Styles.Container>
)

export default EmailTemplateDetailSkeleton
